import React, { ReactNode } from 'react'
import { IconS24LetterSent48, IconS24Telephone48, IconS24UserTie48 } from '@is24/cosma-ui-icons'
import './ConsultationBanner.scss'

const BannerTile: React.FC<{ icon: ReactNode }> = ({ icon, children }) => (
  <div className='ConsultationBannerTile'>
    <div className='ConsultationBannerIcon'>{icon}</div>
    <div className='ConsultationBannerContent'>{children}</div>
  </div>
)

const ConsultationBanner: React.FC = () => (
  <div className='ConsultationBanner'>
    <BannerTile icon={<IconS24Telephone48 />}>
      <div>Du erreichst uns kostenlos unter</div>
      <div>
        <a className='ConsultationBannerLink' href='tel:030243011450'>
          030 24 301 14 50
        </a>
      </div>
      <div>(Mo - Fr von 9.00 - 20.00 Uhr)</div>
    </BannerTile>
    <BannerTile icon={<IconS24LetterSent48 />}>
      <div>Oder schreib uns</div>
      <div>
        <a className='ConsultationBannerLink' href='mailto:marktwert@scout24.com'>
          marktwert@scout24.com
        </a>
      </div>
    </BannerTile>
    <BannerTile icon={<IconS24UserTie48 />}>
      Unser Team besteht aus <span className='font-bold'>über 20 fach&shy;kundigen Experten</span>.
    </BannerTile>
  </div>
)

export default ConsultationBanner
